module.exports = __webpack_public_path__ + "static/3-small-4f058c04ed4d19ba8851064855ebb75d.jpg";